import { ApprovalableTypeEnum } from 'api-hooks/common';
import { NavigationRoutes } from 'common/constants';
import { themedStyled } from 'common/styles/styletron.theme';
import HOCWatchValue from 'components/common/hoc-watch-value';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import { ScheduleCardHeader } from '../style';

export default function SettlementCard() {
  const { t } = useTranslation();
  const values = HOCWatchValue({ keys: ['approvalableType', 'approvalable'] });
  const { navigate } = useNavigation();

  const onViewDetails = ({ id, approvalableType }) => {
    const params = {
      id,
    };
    if (approvalableType === ApprovalableTypeEnum.AccountPayable) {
      navigate(NavigationRoutes.AccountPayablesView, params);
    }
    if (approvalableType === ApprovalableTypeEnum.AccountReceivable) {
      navigate(NavigationRoutes.AccountReceivablesView, params);
    }
  };

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <ScheduleCardHeader $style={style}>
        <Text variant="HeadingXSmall">
          {t('common:detail_extra', {
            extra: t('common:settlement'),
          })}
        </Text>
        <Button
          buttonType="secondary"
          onClick={() =>
            onViewDetails({
              id: values.approvalable.id,
              approvalableType: values.approvalableType,
            })
          }
        >
          {t('common:view_details')}
        </Button>
      </ScheduleCardHeader>
      <Separator gap={16} />
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.transactionAt"
            label={t('common:transaction_at')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.number"
            label={t('common:number')}
          />
        </HalfContainer>
      </SectionContainer>
      <FullContainer>
        <Input
          type="text"
          name="approvalable.description"
          label={t('common:description')}
        />
      </FullContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            label={t(
              `common:${
                values.approvalableType === ApprovalableTypeEnum.AccountPayable
                  ? 'agent'
                  : 'customer'
              }`,
            )}
            name={`approvalable.${
              values.approvalableType === ApprovalableTypeEnum.AccountPayable
                ? 'agent'
                : 'customer'
            }`}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="number"
            label={t('debt:total_payment')}
            name="approvalable.totalPayment"
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            label={t('common:payment_method')}
            name="approvalable.paymentMethod"
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            label={values.approvalable.paymentMethod}
            name="approvalable.paymentable"
          />
        </HalfContainer>
      </SectionContainer>
    </CardSection>
  );
}

const style: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
